// extracted by mini-css-extract-plugin
export default {"LoadError":"bfu_a bih_qs bih_a bih_w bih_j bih_q","LoadError__icon":"bfu_b bih_vl bih_fm bih_sw","LoadError__message":"bfu_c bih_fm bih_tr"};